<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l1Tmfg/tc-custom/9781440581625.jpg?1730494635941" alt="This image is the cover for the book 201 Organic Baby and Toddler Meals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">201 Organic Baby and Toddler Meals
      </h1>
      <p class="bookDescription body article font2">
        <b>Tasty, wholesome recipes for growing babies and toddlers!</b><br/><br/>Of course your child's food should always be made of the freshest, healthiest ingredients possible! With <i>201 Organic Baby and Toddler Meals</i>, you can be sure your growing child eats the most nourishing meals nature can offer. With the wholesome recipes in this book, you can create well-balanced, all-natural dishes right in your own home. As simple to prepare as they are nutritious, these yummy baby and toddler meals include:<br/><br/>-Dutch Baked Apple Pancake<br/><br/>-Creamy Spinach Pita Pizza<br/><br/>-Orange Chicken Stir-Fry<br/><br/>-Cinnamon Pineapple Crumble<br/><br/>Every recipe is built to make your life less complicated—whether you're freezing them for later or making a family-friendly dish that will satisfy the whole table. These delicious meals are easy on your child's tummy, the environment, and your schedule!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tamika L. Gardner
      </h2>
      
      <p class="authorDescription body article">Tamika L. Gardner began crafting homemade baby food as a new mother of two seeking to provide fresh meals beyond what any jar on the shelf could offer. As a thrifty mom who exclusively breastfed both children, purchasing pre-packaged food seemed to go against the grain of natural feeding. Therefore, she relied on advice from pediatricians and old-school mamas to make baby purees from whole ingredients. Her organic recipes have been featured on&#160;<I>ABC News</I>,<I></I>iVillage.com, <I>MetroParent</I>,<I> News and Observer</I>,<I></I>BlogHer.com<I>, The Stir</I>,&#160;and&#160;<I>Dot Coms for Moms</I>. Her mission is to encourage parents to nurture healthy children through fresh, whole foods from farm to table.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4a67b50